import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { bloqcibeApi, useExternalVerifyCRFMutation, useGetSubjectAnswersQuery, useGetSubjectDetailQuery, useGetTrialDetailsQuery, useGetTrialSiteInfoQuery, useGetVisitAnswersQuery } from "../../../store/slices/apiSlice";
import { findObjectByKey, getUserRole } from "../../util";
import { forwardRef, useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { base64ToArrayBuffer } from "../../../components/common/DocumentUpload";
import _ from 'lodash';
import { useSpring, animated } from '@react-spring/web';
import SvgIcon from '@mui/material/SvgIcon';
import RightArrow from "../../../components/icons/RightArrow";
import Collapse from '@mui/material/Collapse';
import { alpha, styled, useTheme } from '@mui/material/styles';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import { SKIPPED_FIELDS_KEY } from "../../../util/constants";
import FormDetails from "../subjectDetailCRF/FormDetails";
import { mergeCustomFields } from "../../../util/util";
import originalConfig from '../../subjectCRF/vir_crf.json'
import { openMessage } from "../../../store/slices/showMessageSlice";
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CloseIcon from '@mui/icons-material/Close';
import AuditExportButton from "../../../components/common/AuditExportButton";
import { setUserLocation } from "../../../store/slices/userDetailsSlice";
import CustomButton from "../../../components/@extended/CustomButton";
import QueryListDialog from "../../trialSiteDetails/QueryListDialog";
import SubjectParticipantIdHeading from "../../../components/common/SubjectParticipantIdHeading";
import { setQueries, setQueriesLoading, clearQueries, selectHasOpenQueries, selectQueriesByFieldKey, selectRefetchTrigger } from "../../../store/slices/querySlice";
import BackButton from "../../../components/common/BackButton";
function MinusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14, color: '#FF6602' }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
        </SvgIcon>
    );
}
function PlusSquare(props) {
    return (
        <SvgIcon fontSize="inherit" style={{ width: 14, height: 14, color: '#FF6602' }} {...props}>
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
        </SvgIcon>
    );
}

function CloseSquare(props) {
    return (
        <SvgIcon
            className="close"
            fontSize="inherit"
            style={{ width: 14, height: 14 }}
            {...props}
        >
            {/* tslint:disable-next-line: max-line-length */}
            <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
        </SvgIcon>
    );
}
function TransitionComponent(props) {
    const style = useSpring({
        to: {
            opacity: props.in ? 1 : 0,
            transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
        },
    });

    return (
        <animated.div style={style}>
            <Collapse {...props} />
        </animated.div>
    );
}
const CustomTreeItem = forwardRef((props, ref) => (
    <TreeItem {...props} TransitionComponent={TransitionComponent} ref={ref} />
));

const StyledTreeItem = styled(CustomTreeItem)(({ theme, selected }) => ({
    [`& .${treeItemClasses.iconContainer}`]: {
        '& .close': {
            opacity: 0.3,
        },
    },
    [`& .${treeItemClasses.group}`]: {
        marginLeft: 15,
        paddingLeft: 18,
        borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    [`& .${treeItemClasses.content}`]: {
        backgroundColor: selected ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
        '&:hover': {
            backgroundColor: selected 
                ? alpha(theme.palette.primary.main, 0.12) 
                : alpha(theme.palette.action.hover, 0.08),
        },
        '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.primary.main, 0.16),
            '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
        },
    },
}));

const VisitDetailCRFInfo = (props) => {
    const { subjectStepStatusData } = props;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const crfDocumentKey = useSelector((state) => state?.trial?.trialSiteDetail?.siteTrialData?.trial?.crfForm);
    const [originalFormConfig, setOriginalFormConfig] = useState(null);
    const { trialId, siteId, trialSiteId, subjectMasterId, crfMasterId, visitStepKey } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const sponsorId = useSelector((state) => state.auth.sponsorId);
    const {user: loggedInUser, userData} = useSelector((state) => state.auth);
    const [getLibraryForm] = bloqcibeApi.endpoints.getLibraryForm.useLazyQuery();
    const [selectedForm, setSelectedForm] = useState();
    const [selectedSectionKey, setSelectedSectionKey] = useState();
    const [selectedSubSectionKey, setSelectedSubSectionKey] = useState();
    const [stepCRFStatus, setStepCRFStatus] = useState();
    const [formConfigLoaded, setFormConfigLoaded] = useState(false);
    const [expandedNodes, setExpandedNodes] = useState([]);
    const [selectedNodeId, setSelectedNodeId] = useState(null);
    const [queryDialogOpen, setQueryDialogOpen] = useState(false);
    const [treeDialogOpen, setTreeDialogOpen] = useState(false);

  //START USING V2 API
  const { data: trialDetails } = useGetTrialDetailsQuery({
    id: trialId,
    sponsorId: sponsorId,
  });
  const { locationLat, locationLng } = useSelector((state) => state.userDetails);
  const enrolmentDocumentKey = useSelector(
    (state) => state?.trial?.trialSiteDetail?.siteTrialData?.trial?.eConsentForm
  );
    const [externalVerifyCRF] = useExternalVerifyCRFMutation()
    const [downloadCRFFile] =
        bloqcibeApi.endpoints.downloadCRFFile.useLazyQuery();
    const [formConfig, setFormConfig] = useState(null);
    // const [formConfig, setFormConfig] = useState(originalConfig.steps.find((_obj) => _obj.key === visitStepKey));
    // const [userSiteTrialRole, setUserSiteTrialRole] = useState();
    const [downloadVisitSignature] =
        bloqcibeApi.endpoints.downloadVisitSignature.useLazyQuery();
    const [getEConsentFormConfig, { data: formData }] =
        bloqcibeApi.endpoints.getEConsentFormConfig.useLazyQuery();
    const [getQueries] = bloqcibeApi.endpoints.getQueries.useLazyQuery();
    
    // Query selectors from Redux
    const hasOpenQueries = useSelector(selectHasOpenQueries);
    const queriesByFieldKey = useSelector(selectQueriesByFieldKey);
    const refetchTrigger = useSelector(selectRefetchTrigger);
    const { data: subjectDetailWithSteps } = useGetSubjectDetailQuery(subjectMasterId);
    const [getVisitAnswers, { data: visitDetails }] = bloqcibeApi.endpoints.getVisitAnswers.useLazyQuery();
    const crfStepStatus = useMemo(() => {
        if (subjectDetailWithSteps) {
            const steps = _.sortBy(subjectDetailWithSteps?.crfDetail?.stepStatus, 'order');
            return steps;
        }
        return [];
    }, [subjectDetailWithSteps]);

    const { data: trialSiteData } = useGetTrialSiteInfoQuery({
        sponsorId: sponsorId,
        trialId: trialId,
        siteTrialId: trialSiteId,
    });

    const userSiteTrialRole = useMemo(() => {
      return getUserRole(loggedInUser, trialId, siteId, userData);
    }, [loggedInUser, trialSiteData, userData]);
  
    // State for notification focused field
    const [selectedfield, setSelectedField] = useState(null)


    useEffect(() => {
      (async () => {
        let _config = null;
        setFormConfigLoaded(false);
        const _formDetailsData = await getLibraryForm(
          `${process.env.REACT_APP_API_ENDPOINT_URL}form-library/library/bloqcube/${crfDocumentKey}`
        );
        if (_formDetailsData.data) {
          setOriginalFormConfig(_formDetailsData.data);
          setFormConfigLoaded(true);
        } else if (_formDetailsData.error) {
          console.error('UNABLE TO GET FORM DETAILS');
          setFormConfigLoaded(true); // Set to true even on error to allow fallback
        }
        if (trialSiteData) {
          const formDetailsData = await getEConsentFormConfig({
            sponsorId,
            trialId,
            siteId: trialSiteData.siteTrialData.siteId,
            documentKey: crfDocumentKey,
            payload: {
              subjectMasterId: subjectMasterId,
            },
          });
          if (formDetailsData.data) {
            let _tempConfig = { ..._formDetailsData.data };
            // let _tempConfig = originalConfig;
            const mergedConfig = mergeCustomFields(_tempConfig, formDetailsData.data);
            setFormConfig(mergedConfig.steps.find((_obj) => _obj.key === visitStepKey));
          } else if (formDetailsData.error) {
            console.error('UNABLE TO GET FORM DETAILS');
          } else {
            // setFormConfig(originalConfig.steps.find((_obj) => _obj.key === visitStepKey));
            setFormConfig(
                _formDetailsData.data.steps.find((_obj) => _obj.key === visitStepKey)
            );
          }
          // await getVisitAnswers({
          //     sponsorId: sponsorId,
          //     trialId: trialId,
          //     siteId: trialSiteData?.siteTrialData?.site?.id,
          //     payload: {
          //         crfMasterId: crfMasterId,
          //         subjectMasterId: subjectMasterId,
          //         stepKey: visitStepKey,
          //         crfMasterId: crfMasterId,
          //     }
          // })
        }
      })();
    }, [trialSiteData]);

    useEffect(() => {
      if (formConfig && trialSiteData) {
        (async () => {
          console.log("Fetching visit answers for section key", selectedSectionKey, "and sub section key", selectedSubSectionKey);
          const result = await getVisitAnswers({
            sponsorId: sponsorId,
            trialId: trialId,
            siteId: trialSiteData?.siteTrialData?.site?.id,
            payload: {
              crfMasterId: crfMasterId,
              subjectMasterId: subjectMasterId,
              stepKey: visitStepKey,
              crfMasterId: crfMasterId,
              sectionKey: selectedSectionKey,
              subSectionKey: selectedSubSectionKey,
            },
          });
        })();
      }
    }, [formConfig, trialSiteData, selectedSectionKey, selectedSubSectionKey]);

    // Fetch queries for the selected form (CRF)
    useEffect(() => {
      const fetchQueries = async () => {
        if (!sponsorId || !trialId || !siteId || !subjectMasterId || !visitStepKey || !selectedSectionKey || !crfMasterId) {
          return;
        }
        
        dispatch(setQueriesLoading(true));
        try {
          const result = await getQueries({
            sponsorId,
            trialId,
            siteId,
            stepKey: visitStepKey,
            sectionKey: selectedSectionKey,
            subSectionKey: selectedSubSectionKey,
            subjectMasterId,
            crfMasterId,
            page: 1,
            limit: 100,
            active: true,
          });

          if (result.data) {
            const fetchedQueries = result.data.data || [];
            dispatch(setQueries(fetchedQueries));
          } else {
            dispatch(setQueries([]));
          }
        } catch (error) {
          console.error('Error fetching queries:', error);
          dispatch(setQueries([]));
        }
      };

      fetchQueries();
    }, [sponsorId, trialId, siteId, subjectMasterId, visitStepKey, selectedSectionKey, selectedSubSectionKey, crfMasterId, dispatch, getQueries, refetchTrigger]);

    // Clear queries when component unmounts
    useEffect(() => {
      return () => {
        dispatch(clearQueries());
      };
    }, [dispatch]);
    
  
  useEffect(() => {
    if (!formConfig || !formConfigLoaded) return;

    // Read from URL query params first
    const querySectionKey = searchParams.get('sectionKey');
    const querySubSectionKey = searchParams.get('subSectionKey');
    const queryFieldKey = searchParams.get('fieldKey');

    if (querySectionKey) {
      // Use query params if available
      const sectionConfig = _.find(formConfig.sections, ({ key }) => key === querySectionKey);
      if (sectionConfig) {
        const subSectionConfig = querySubSectionKey ? _.find(sectionConfig.subTabs, ({ key }) => key === querySubSectionKey) : null;
        setSelectedSectionKey(querySectionKey);
        setSelectedSubSectionKey(querySubSectionKey || null);
        setSelectedForm(subSectionConfig || sectionConfig);
        if (queryFieldKey) setSelectedField(queryFieldKey);
        
        // Set expanded nodes and selected node
        setExpandedNodes([querySectionKey]);
        setSelectedNodeId(querySubSectionKey ? `${querySectionKey}@${querySubSectionKey}` : querySectionKey);
      }
    } else if (state) {
      // Fallback to state
      const { fieldKey, sectionKey, subSectionKey } = state;
      setSelectedField(fieldKey);
      setSelectedSectionKey(sectionKey);
      const sectionConfig = _.find(formConfig.sections, ({ key }) => key === sectionKey);
      const subSectionConfig = subSectionKey ? _.find(sectionConfig.subTabs, ({ key }) => key === subSectionKey) : null;
      setSelectedSubSectionKey(subSectionKey || null);
      setSelectedForm(subSectionConfig || sectionConfig);

      // Set expanded nodes and selected node
      setExpandedNodes([sectionKey]);
      setSelectedNodeId(subSectionKey ? `${sectionKey}@${subSectionKey}` : sectionKey);

      // Update URL with initial selection
      const params = new URLSearchParams();
      params.set('sectionKey', sectionKey);
      if (subSectionKey) params.set('subSectionKey', subSectionKey);
      if (fieldKey) params.set('fieldKey', fieldKey);
      setSearchParams(params, { replace: true });
    } else if (userSiteTrialRole === 'site_monitor' && crfStepStatus) {
      const stepStatusData = crfStepStatus.find(({ stepKey }) => stepKey === visitStepKey);
      const verificationPendingSection = stepStatusData?.sectionStatuses.find(
        ({ status }) => status === 'External_Verification_Pending'
      );
      if (verificationPendingSection) {
        const { sectionKey } = verificationPendingSection;
        setSelectedSectionKey(sectionKey);
        const verificationPendingSectionConfig = _.find(formConfig.sections, ({ key }) => key === sectionKey);
        const verificationPendingSubSection = verificationPendingSection.subSectionStatuses?.find(
          ({ status }) => status === 'External_Verification_Pending'
        );
        const verificationPendingSubSectionKey = verificationPendingSubSection?.subSectionKey;
        const verificationPendingSubSectionConfig = verificationPendingSubSectionKey
          ? _.find(verificationPendingSectionConfig.subTabs, ({ key }) => key === verificationPendingSubSectionKey)
          : null;

        const params = new URLSearchParams();
        params.set('sectionKey', sectionKey);
        if (verificationPendingSubSectionKey) params.set('subSectionKey', verificationPendingSubSectionKey);
        setSearchParams(params, { replace: true });

        setSelectedSubSectionKey(verificationPendingSubSectionKey || null);
        setSelectedForm(verificationPendingSubSectionConfig || verificationPendingSectionConfig);
        
        // Set expanded nodes and selected node
        setExpandedNodes([sectionKey]);
        setSelectedNodeId(verificationPendingSubSectionKey ? `${sectionKey}@${verificationPendingSubSectionKey}` : sectionKey);
      }
    } else {
      const defaultSection = formConfig.sections[0];
      setSelectedForm(defaultSection.subTabs?.[0] || defaultSection);
      setSelectedSectionKey(defaultSection.key);
      setSelectedSubSectionKey(defaultSection.subTabs?.[0]?.key || null);

      // Set expanded nodes and selected node
      setExpandedNodes([defaultSection.key]);
      setSelectedNodeId(defaultSection.subTabs?.[0]?.key ? `${defaultSection.key}@${defaultSection.subTabs[0].key}` : defaultSection.key);

      // Update URL with default selection
      const params = new URLSearchParams();
      params.set('sectionKey', defaultSection.key);
      if (defaultSection.subTabs?.[0]?.key) params.set('subSectionKey', defaultSection.subTabs[0].key);
      setSearchParams(params, { replace: true });
    }
  }, [formConfig, state, userSiteTrialRole, crfStepStatus, visitStepKey, formConfigLoaded, searchParams, setSearchParams]);

  const handleDownloadSignature = useCallback(async (s3Key, setSign) => {
    try {
      const result = await downloadVisitSignature({
        s3Key: s3Key,
      });
      if (result.data) {
        const byteArray = base64ToArrayBuffer(result.data);
        const rr = new Blob([byteArray], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(rr);
        reader.onloadend = function () {
          const base64data = reader.result;
          setSign(base64data);
        };
        reader.onerror = function () {
          console.log('Failed to read signature data');
          setSign(null);
        };
      } else {
        console.log('Failed to load signature');
        setSign(null);
      }
    } catch (error) {
      console.error('Error downloading signature:', error);
      setSign(null);
    }
  }, [downloadVisitSignature]);
    const openStepForm = (stepKey) => {
        const params = new URLSearchParams();
        if (selectedSectionKey) params.set('sectionKey', selectedSectionKey);
        if (selectedSubSectionKey) params.set('subSectionKey', selectedSubSectionKey);
        navigate(`/eConcent/${trialId}/trial-site/${trialSiteId}/${visitStepKey}/${subjectMasterId}/crf/${crfMasterId}?${params.toString()}`);
    };
    function findObjectByValue(
        obj,
        targetValue,
        path = [],
    ) {
        for (const key in obj) {
            if (obj[key] === targetValue) {
                return obj;
            } else if (typeof obj[key] === "object" && obj[key] !== null) {
                // Continue searching in the nested object
                const result = findObjectByValue(
                    obj[key],
                    targetValue,
                    [...path, key],
                );
                if (result) {
                    return result;
                }
            }
        }
        // Value not found in the current object
        return null;
    }
    const onFormSelect = (e, node) => {
        const _sectionKey = node.split('@')[0];
        const _subSectionKey = node.split('@')[1];
        const _sec = findObjectByValue(formConfig, _subSectionKey ? _subSectionKey : _sectionKey);
        if (_sec && !_sec.subTabs) {
            setSelectedSectionKey(_sectionKey);
            setSelectedSubSectionKey(_subSectionKey);
            setSelectedForm(_sec);

            // Update expanded nodes and selected node
            setExpandedNodes([_sectionKey]);
            setSelectedNodeId(_subSectionKey ? `${_sectionKey}@${_subSectionKey}` : _sectionKey);

            // Update URL query params
            const params = new URLSearchParams(searchParams);
            params.set('sectionKey', _sectionKey);
            if (_subSectionKey) {
              params.set('subSectionKey', _subSectionKey);
            } else {
              params.delete('subSectionKey');
            }
            // Remove fieldKey and tab when selecting a new section
            params.delete('fieldKey');
            params.delete('tab');
            setSearchParams(params, { replace: true });

            if (isMobile) {
                setTreeDialogOpen(false);
            }
        }
    }

    const handleNodeToggle = (event, nodeIds) => {
        setExpandedNodes(nodeIds);
    };
    const editAllowed = useMemo(() => {
        const stepStatusData = crfStepStatus.find((_obj) => _obj.stepKey === visitStepKey);
        
        // Block editing for terminal statuses
        if (
            stepStatusData &&
            ['Withdrawal', 'Enrollment_Failure', 'Screening_Failure', 'On_Hold'].includes(stepStatusData.status)
        ) {
            return false;
        }

        if (stepStatusData && stepStatusData.userAccess) {
            const userAccess = JSON.parse(stepStatusData.userAccess);
            const editAccess = userAccess.edit;
            const isAccess = typeof editAccess !== "string" ? _.find(editAccess, (access) => {
                return access == userSiteTrialRole;
            }) : editAccess === userSiteTrialRole;
          
            // Check readOnlyEdit configuration from step config
            // This allows role-based editing for specific form statuses
            const readOnlyEditConfig = formConfig?.readOnlyEdit;
            
            // Allow edit if user has edit access
            if (isAccess && !readOnlyEditConfig) {
                return true;
            }
            
            if (readOnlyEditConfig) {
                const currentStatus = stepStatusData.status;

                // Check granular status-based role access
                // Format: { "statusAccess": { "Pending": ["PI"], "Completed": ["site_monitor"] } }
                if (readOnlyEditConfig.statusAccess && readOnlyEditConfig.statusAccess[currentStatus]) {
                    const statusRoles = readOnlyEditConfig.statusAccess[currentStatus];
                    const hasStatusAccess = Array.isArray(statusRoles)
                        ? statusRoles.includes(userSiteTrialRole)
                        : statusRoles === userSiteTrialRole;

                    if (hasStatusAccess) {
                        return true;
                    }
                }

                // Check legacy format: allowApplicableStatus + roles
                // Format: { "allowApplicableStatus": ["Pending"], "roles": ["PI", "site_coordinator"] }
                const allowApplicableStatus = readOnlyEditConfig.allowApplicableStatus || [];
                const readOnlyEditRoles = readOnlyEditConfig.roles || readOnlyEditConfig.access?.edit || [];

                if (allowApplicableStatus.length > 0) {
                    const isStatusAllowed = allowApplicableStatus.includes(currentStatus);
                    const hasReadOnlyEditAccess = Array.isArray(readOnlyEditRoles)
                        ? readOnlyEditRoles.includes(userSiteTrialRole)
                        : readOnlyEditRoles === userSiteTrialRole;

                    if (isStatusAllowed && hasReadOnlyEditAccess) {
                        return true;
                    }
                }
            }
            
            // Allow edit if there are open queries on the form (for resolving queries)
            if (hasOpenQueries) {
                const currentStatus = stepStatusData.status;
                const verifyAccess = userAccess.verify;
                const hasVerifyAccess = _.find(verifyAccess, (access) => access === userSiteTrialRole);

                // Allow editing for users with verify access when there are open queries
                if (hasVerifyAccess) {
                    return true;
                }

                // Check readOnlyEdit for open queries - use queryResolutionAccess or statusAccess
                if (readOnlyEditConfig) {
                    // Specific query resolution roles
                    // Format: { "queryResolutionAccess": ["PI", "site_coordinator", "site_monitor"] }
                    if (readOnlyEditConfig.queryResolutionAccess) {
                        const queryRoles = readOnlyEditConfig.queryResolutionAccess;
                        const hasQueryAccess = Array.isArray(queryRoles)
                            ? queryRoles.includes(userSiteTrialRole)
                            : queryRoles === userSiteTrialRole;

                        if (hasQueryAccess) {
                            return true;
                        }
                    }

                    // Check if user has access for current status via statusAccess
                    if (readOnlyEditConfig.statusAccess && readOnlyEditConfig.statusAccess[currentStatus]) {
                        const statusRoles = readOnlyEditConfig.statusAccess[currentStatus];
                        const hasStatusAccess = Array.isArray(statusRoles)
                            ? statusRoles.includes(userSiteTrialRole)
                            : statusRoles === userSiteTrialRole;

                        if (hasStatusAccess) {
                            return true;
                        }
                    }

                    // Fallback to legacy roles
                    const readOnlyEditRoles = readOnlyEditConfig.roles || readOnlyEditConfig.access?.edit || [];
                    const hasReadOnlyEditAccess = Array.isArray(readOnlyEditRoles)
                        ? readOnlyEditRoles.includes(userSiteTrialRole)
                        : readOnlyEditRoles === userSiteTrialRole;

                    if (hasReadOnlyEditAccess) {
                        return true;
                    }
                }
            }
            
            return false;
        }
        return false;
    }, [crfStepStatus, userSiteTrialRole, visitStepKey, hasOpenQueries, formConfig]);
    const handleDownloadFile = async (s3Key, fileName) => {
        const result = await downloadCRFFile({
            s3Key: s3Key,
        });
        if (result.data) {
            let byteArray = base64ToArrayBuffer(result.data);
            let a = window.document.createElement("a");
            a.href = window.URL.createObjectURL(
                new Blob([byteArray], { type: "application/octet-stream" })
            );
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
        } else {
            console.log("Failed to load file");
        }
    }

    const readOnlyActions = useMemo(() => {
        if (formConfig) {
            return formConfig?.readOnlyActions
        }
        return null
    }, [formConfig])

    const selectedFormStatus = useMemo(() => {
        if (subjectDetailWithSteps&&selectedForm) {
            const steps = _.find(subjectDetailWithSteps?.crfDetail?.stepStatus, (_step) => _step.stepKey === visitStepKey);
            setStepCRFStatus(steps)
            let statusData = findObjectByValue(steps, selectedForm.key)
            return statusData?.status;
        }
        return null;
    }, [subjectDetailWithSteps,selectedForm]);
    
    const getGeoLocation = async () => {
      if ('geolocation' in navigator) {
        return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
              if (latitude && longitude) {
                dispatch(setUserLocation({ locationLatitude: latitude, locationLongitude: longitude }));
                resolve({ latitude, longitude });
              } else {
                resolve({ latitude: 0.0, longitude: 0.0 });
              }
            },
            (error) => {
              dispatch(
                openMessage({
                  message: 'Please enable location access to submit your response.',
                  messageSeverity: 'error',
                })
              );
              console.error(`Error getting geolocation: ${error.message}`);
              reject(error);
            }
          );
        });
      } else {
        dispatch(openMessage({ message: 'Geolocation is not supported!', messageSeverity: 'error' }));
        console.log('Geolocation is not supported');
        return { latitude: 0.0, longitude: 0.0 };
      }
    };

    const handleSubjectVerification = async (payload) => {
        let _ans = {}
        if (selectedForm) {
          selectedForm?.categories &&
            selectedForm?.categories.forEach((category) => {
              const _answers = findObjectByKey(payload?.answers, category.key);
              if (_answers) _ans[category.key] = _answers;
            });
          selectedForm?.fields &&
            selectedForm?.fields.forEach((field) => {
              const _answer = findObjectByKey(payload?.answers, field.key);
              if (_answer) _ans[field.key] = _answer;
            });
        }
        if (!_ans.locationLongitude || !_ans.locationLatitude) {
          let locationLongitude;
          let locationLatitude;
          if (!locationLat || !locationLng) {
            try {
              const co_ords = await getGeoLocation();
              const { latitude, longitude } = co_ords;
              locationLongitude = longitude;
              locationLatitude = latitude;
            } catch (error) {
              // User denied geolocation - use default coordinates
              locationLongitude = 0.0;
              locationLatitude = 0.0;
            }
          } else {
            locationLongitude = locationLng;
            locationLatitude = locationLat;
          }
          _ans.locationLongitude = locationLongitude;
          _ans.locationLatitude = locationLatitude;
        }
        const verify = await externalVerifyCRF({
          sponsorId,
          trialId,
          siteId,
          payload: {
            crfMasterId: crfMasterId,
            subjectMasterId: subjectMasterId,
            documentKey: enrolmentDocumentKey,
            documentVersion: '1.0',
            crfDocumentKey: crfDocumentKey,
            crfDocumentVersion: '1.0',
            stepKey: payload.stepKey,
            sectionKey: payload.sectionKey,
            subSectionKey: payload.subSectionKey,
            answers: _ans,
          },
        });
        if (verify.data) {
          dispatch(
            openMessage({
              message: 'Verified Sucessfully!',
              messageSeverity: 'success',
            })
          );
        } else if (
          verify?.error?.data?.message?.includes('External verification is not allowed because there are queries for')
        ) {
          dispatch(
            openMessage({
              message:
                'Verification is not allowed because there are queries for this form that are not in VERIFIED state. Please verify all queries and try again.',
              messageSeverity: 'error',
            })
          );
        } else {
          dispatch(
            openMessage({
              message: 'Verification request failed!',
              messageSeverity: 'error',
            })
          );
        }
    }

    const renderFormTreeView = () => (
      <TreeView
        expanded={expandedNodes}
        selected={selectedNodeId}
        onNodeToggle={handleNodeToggle}
        onNodeSelect={onFormSelect}
        defaultCollapseIcon={<MinusSquare />}
        defaultExpandIcon={<PlusSquare />}
        sx={{ overflowX: 'hidden' }}
      >
        {formConfig &&
          formConfig.sections.map((section) => {
            let sectionSatus = stepCRFStatus?.sectionStatuses.find((a) => a.sectionKey === section.key);
            return (
              (sectionSatus?.status !== 'Pending' ||
                (sectionSatus?.subSectionStatuses &&
                  sectionSatus.subSectionStatuses.some((subSec) => subSec.status !== 'Pending'))) &&
              (section.showInReadOnly == undefined || section.showInReadOnly) && (
                <StyledTreeItem
                  key={`${section.key}`}
                  nodeId={`${section.key}`}
                  selected={selectedNodeId === section.key && !selectedSubSectionKey}
                  sx={{
                    '& .MuiTreeItem-content': {
                      paddingY: 1,
                    },
                  }}
                  label={
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 0.5,
                        pr: 0,
                      }}
                    >
                      <Typography variant="subtitle1" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
                        {section.label}
                      </Typography>
                      {sectionSatus?.status === 'External_Verification_Pending' && (
                        <PendingActionsRoundedIcon
                          sx={{
                            color: theme.palette.primary.light,
                            fontSize: 23,
                          }}
                        />
                      )}
                    </Box>
                  }
                >
                  {section &&
                    section.subTabs &&
                    section.subTabs.map((subTab) => {
                      let subSectionSatus = sectionSatus?.subSectionStatuses.find(
                        (a) => a.subSectionKey === subTab.key
                      );
                      return (
                        !SKIPPED_FIELDS_KEY.includes(subTab.key) &&
                        subSectionSatus?.status !== 'Pending' &&
                        (subTab.showInReadOnly == undefined || subTab.showInReadOnly) && (
                          <StyledTreeItem
                            key={`${section.key}@${subTab.key}`}
                            nodeId={`${section.key}@${subTab.key}`}
                            selected={selectedNodeId === `${section.key}@${subTab.key}`}
                            label={subTab.label}
                          />
                        )
                      );
                    })}
                </StyledTreeItem>
              )
            );
          })}
      </TreeView>
    );

    return (
      <Box>
        <Box sx={{ position: 'relative', display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', pb: 2 }}>
          <BackButton backHandler={() => navigate(-1)} />
          <SubjectParticipantIdHeading />
          <Box sx={{ display: 'flex', flexShrink: 0, alignItems: 'center' }}>
            {isMobile && (
              <Tooltip title="Select Form" arrow placement="top">
                <IconButton
                  aria-label="open form selection"
                  onClick={() => setTreeDialogOpen(true)}
                  size="small"
                  sx={{ mr: 1 }}
                >
                  <AccountTreeIcon />
                </IconButton>
              </Tooltip>
            )}
            {(userSiteTrialRole === 'site_monitor' ||
              userSiteTrialRole === 'PI' ||
              userSiteTrialRole === 'site_coordinator') && (
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
                <CustomButton variant={'contained'} size="small" onClick={() => setQueryDialogOpen(true)}>
                  <Typography variant="subtitle2" color="inherit" fontWeight={600}>
                    Queries
                  </Typography>
                </CustomButton>
              </Box>
            )}
            {userSiteTrialRole === 'site_monitor' || userSiteTrialRole === 'sponsor' ? (
              <AuditExportButton
                subjectNumber={subjectDetailWithSteps?.subjectNumber}
                stepKey={visitStepKey}
                protocolNumber={trialDetails?.trialData?.protocolNumber}
              />
            ) : (
              ''
            )}
          </Box>
        </Box>
        <Box sx={{ display: 'flex', width: '100%', flexDirection: isMobile ? 'column' : 'row' }}>
          {!isMobile && (
            <Box
              sx={{
                width: '30%',
                paddingTop: 2,
                paddingX: 2,
                border: '1px solid #E7E7E7',
                position: 'sticky',
                position: '-webkit-sticky',
                top: 'auto',
              }}
            >
              {renderFormTreeView()}
            </Box>
          )}
          <Box sx={{ width: isMobile ? '100%' : '70%', paddingX: isMobile ? 0 : 1 }}>
            {selectedForm && (
              <FormDetails
                selectedfield={selectedfield}
                setSelectedField={setSelectedField}
                details={selectedForm}
                handleDownload={handleDownloadFile}
                sectionKey={selectedSectionKey}
                openStepForm={openStepForm}
                stepKey={visitStepKey}
                editAllowed={editAllowed}
                subSectionKey={selectedSubSectionKey}
                formStatus={selectedFormStatus}
                handleDownloadSignature={handleDownloadSignature}
                userSiteTrialRole={userSiteTrialRole}
                readOnlyActions={readOnlyActions}
                answers={visitDetails}
                verifyAction={handleSubjectVerification}
                subjectName={subjectDetailWithSteps && subjectDetailWithSteps?.subjectName}
                queriesByFieldKey={queriesByFieldKey}
                hasOpenQueries={hasOpenQueries}
              />
            )}
            {!selectedForm && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography sx={{ color: 'grey' }}>Please select the form..</Typography>
              </Box>
            )}
          </Box>
        </Box>
        <QueryListDialog
          open={queryDialogOpen}
          onClose={() => setQueryDialogOpen(false)}
          sponsorId={sponsorId}
          trialId={trialId}
          siteId={siteId}
          trialSiteId={trialSiteId}
          stepKey={visitStepKey}
          sectionKey={selectedSectionKey}
          subSectionKey={selectedSubSectionKey}
          subjectMasterId={subjectMasterId}
          crfMasterId={crfMasterId}
        />
        {isMobile && (
          <Dialog fullScreen open={treeDialogOpen} onClose={() => setTreeDialogOpen(false)}>
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: 1.5,
                px: 2,
              }}
            >
              <Typography variant="h6" component="span">
                Select Form
              </Typography>
              <IconButton aria-label="close form selection" onClick={() => setTreeDialogOpen(false)} edge="end">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 2 }}>
              {renderFormTreeView()}
            </DialogContent>
          </Dialog>
        )}
      </Box>
    );
}

export default VisitDetailCRFInfo;